"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }





const UNAVAILABLE = 'Original message unavailable'

 const resolveReplyPreview = (
  preview,
  target,
) => {
  if (!preview && !target) return undefined

  const recalled = Boolean(_optionalChain([target, 'optionalAccess', _ => _.recalled]) || _optionalChain([preview, 'optionalAccess', _2 => _2.Recalled]))
  const displayName = _optionalChain([preview, 'optionalAccess', _3 => _3.DisplayName]) || _optionalChain([target, 'optionalAccess', _4 => _4.displayName]) || 'Unknown sender'
  if (recalled) {
    return { recalled: true, displayName, content: 'Message recalled' }
  }

  const content = _optionalChain([preview, 'optionalAccess', _5 => _5.Snippet]) || _optionalChain([preview, 'optionalAccess', _6 => _6.FileName]) ||
    _optionalChain([target, 'optionalAccess', _7 => _7.snippet]) || _optionalChain([target, 'optionalAccess', _8 => _8.fileName]) || UNAVAILABLE
  const thumbnailURL = _optionalChain([target, 'optionalAccess', _9 => _9.thumbnailURL]) || _optionalChain([preview, 'optionalAccess', _10 => _10.ThumbnailURL]) || undefined
  const mime = _optionalChain([target, 'optionalAccess', _11 => _11.thumbnailURL]) ? target.mime : _optionalChain([preview, 'optionalAccess', _12 => _12.Mime])

  return {
    recalled: false,
    displayName,
    content,
    ...(thumbnailURL ? { thumbnailURL, mime, fileKey: _optionalChain([target, 'optionalAccess', _13 => _13.fileKey]) } : {}),
  }
}; exports.resolveReplyPreview = resolveReplyPreview
